interface Props {
  src?: string;
}

export default function MinisiteMap({ src }: Props) {
  if (!src) return null;

  return (
    <section className="h-56 rounded-2xl overflow-hidden">
      <iframe
        className="w-full h-full"
        src={src}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </section>
  );
}
